<div class="outer" #outer>
    <signature-pad [options]="signaturePadOptions" (beginEvent)="drawStart()" (endEvent)="drawComplete()" #sigPad></signature-pad>
    <!-- <canvas #myCanvas (touchstart)="handleStart($event)" (touchmove)="handleMove($event)"></canvas> -->
</div>